module.exports = __webpack_public_path__ + "img/pdf.c4ec13b7.png";